export let AffinityGroupFieldsJSON = {
  "1717412387761-email": {
    elementid: 1717412387761,
    elementtype: "email",
    "display-required": 1,
    "display-fieldlabel": "Email",
    "database-label": "pri_contact_email",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "validation-pattern": "^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
  },
  "1717412308306-customSelect": {
    elementid: 1717412308306,
    elementtype: "customSelect",
    "display-fieldlabel": "AG Category",
    "display-required": 1,
    "data-datasource": "customvalues",
    "data-customvalue": [],
    "database-label": "buss_category",
    "display-placeholder": "Select",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    // "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  "1717412315194-customSelect": {
    elementid: 1717412315194,
    elementtype: "customSelect",
    "display-required": 1,
    "database-label": "status",
    "data-datasource": "customvalues",
    "data-customvalue": "ACTIVE#INACTIVE",
    "display-fieldlabel": "Status",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
  },
  "1717412405877-phoneNumber": {
    elementid: 1717412405877,
    elementtype: "phoneNumber",
    "display-fieldlabel": "Contact Number",
    "database-label": "pri_contact_number",
    "display-placeholder": "Enter",
    "display-labelposition": "top",
    "validation-maxlength": "10",
    "validation-pattern": "^[0-9+\\-\\s()]*$",
    "display-required": 1,
  },
  "1717412292824-columns": {
    elementid: 1717412292824,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1717412297658-columns": {
    elementid: 1717412297658,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1717412338444-columns": {
    elementid: 1717412338444,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1717412346075-columns": {
    elementid: 1717412346075,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1717412351926-columns": {
    elementid: 1717412351926,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1717412274041-fieldset": {
    elementid: 1717412274041,
    elementtype: "fieldset",
    "display-legend": "Company Details",
    "display-fieldlabel": "Field Set",
  },
  "1717412322677-fieldset": {
    elementid: 1717412322677,
    elementtype: "fieldset",
    "display-legend": "Primary Contact",
    "display-fieldlabel": "Field Set",
  },
  "1717412302140-textfield": {
    elementid: 1717412302140,
    elementtype: "textfield",
    "display-fieldlabel": "AG Name",
    "display-required": 1,
    "database-label": "name",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  "1717412375477-textfield": {
    elementid: 1717412375477,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "Name",
    "database-label": "pri_contact_name",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  "1717412412343-textfield": {
    elementid: 1717412412343,
    elementtype: "textfield",
    "display-fieldlabel": "Department",
    "database-label": "department",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1717412415059-textfield": {
    elementid: 1717412415059,
    elementtype: "textfield",
    "display-fieldlabel": "Designation",
    "database-label": "pri_contact_designation",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1717412308300-textfield": {
    elementid: 1717412308300,
    elementtype: "textfield",
    "display-fieldlabel": "Slug",
    "display-required": 1,
    "database-label": "base_code",
    "display-placeholder": "Enter",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "validation-pattern": "^[a-zA-Z0-9_-]+$*",
  },
  "1717412322677-textfield": {
    elementid: 1717412322677,
    elementtype: "textfield",
    "display-fieldlabel": "Registration Number",
    "display-required": 1,
    "database-label": "registration_number",
    "display-placeholder": "Enter",
    "validation-maxlength": "200",
    "display-labelposition": "top",
    "display-disabled": 0,
  },
};
